module.exports = "https://cdn.littlereply.com/tt/resource/tt_loading.de99714500b56863e174b32129a18064.gif";